"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _CustomFieldsOptions = require("../../CustomFieldsOptions");
var _hooks = require("../../hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.005 3a1 1 0 0 1 1 1v7.01H20a1 1 0 1 1 0 2h-6.995V20a1 1 0 1 1-2 0v-6.99H4a1 1 0 1 1 0-2h7.005V4a1 1 0 0 1 1-1z"
  }));
};
PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "custom-field-adder": "custom-field-adder_3-e-zl",
  "customFieldAdder": "custom-field-adder_3-e-zl",
  "add-filter-button": "add-filter-button_28WwMO",
  "addFilterButton": "add-filter-button_28WwMO",
  "plus-icon": "plus-icon_3h16Xc",
  "plusIcon": "plus-icon_3h16Xc",
  "button-as-anchor": "button-as-anchor_2v3CK8",
  "buttonAsAnchor": "button-as-anchor_2v3CK8"
}; 
require('./CustomFieldAdder.css');
const DROPDOWN_ID = 'custom-field-adder-dropdown';
const CustomFieldAdder = ({
  options,
  onCustomFieldSelected
}) => {
  const buttonRef = (0, _react.useRef)();
  const onClose = (0, _react.useCallback)(() => {
    var _buttonRef$current;
    (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
  }, []);
  const {
    handleBlur,
    handleKeyDown,
    isExpanded,
    toggleDropdown,
    closeDropdown
  } = (0, _hooks.useDropdown)({
    onClose
  });
  const handleSelection = (0, _react.useCallback)(customField => {
    closeDropdown();
    onCustomFieldSelected(customField);
  }, [onCustomFieldSelected, closeDropdown]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react.default.createElement("div", {
      className: styles.customFieldAdder,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: (0, _classnames.default)(styles.addFilterButton, styles.buttonAsAnchor),
      ref: buttonRef,
      onClick: toggleDropdown,
      "aria-controls": DROPDOWN_ID,
      "aria-haspopup": "listbox",
      "aria-expanded": isExpanded
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "xs",
      className: styles.plusIcon
    }, /*#__PURE__*/_react.default.createElement(PlusIcon, null)), /*#__PURE__*/_react.default.createElement("span", null, "Add custom field")), isExpanded && /*#__PURE__*/_react.default.createElement(_CustomFieldsOptions.CustomFieldsOptions, {
      id: DROPDOWN_ID,
      options: options,
      onChange: handleSelection
    }))
  );
};
var _default = exports.default = CustomFieldAdder;
//# sourceMappingURL=CustomFieldAdder.js.map